import { IValidator, ISellPackage } from '@/Interfaces';
import { PackageValidator } from './PackageValidator';
import { PackageSellInfoValidator } from './PackageSellInfoValidator';
import { IAsyncValidator } from '@/Interfaces/IValidator';
import { Validations } from '@samc/common-ui';

/**
 * Validator for Sell Package
 */
export class SellPackageValidator implements IValidator<ISellPackage>, IAsyncValidator<ISellPackage> {
  
  private _packageValidator: PackageValidator = new PackageValidator();
  private _packageSellInfoValidator: PackageSellInfoValidator = new PackageSellInfoValidator ();

  public isValid(value: ISellPackage, shouldValidateName?: boolean): Record<string, string> {
    const validations = this._packageValidator.isValid(value, shouldValidateName);
    if (value.packageSellInfo) {
      const innerValidations = this._packageSellInfoValidator.isValid(value.packageSellInfo, value.status);
      for (let i in innerValidations) {
        validations[`packageSellInfo.${i}`] = innerValidations[i];
      }
     
      if (!value.name) {
        validations.name = validations['name'] = this.getRequiredFieldValidationMessage('Deal Name');
      }
      if (!value.packageSubType || !value.packageSubType.id) {
        validations['packageSubType'] = validations.packageSubType = this.getRequiredFieldValidationMessage('Deal Type');
      }
      if (!value.assetClass || !value.assetClass.id) {
        validations.assetClass = 'Asset Class is required';
      }

      // Handle required validations based on status
      if (value.status === 'Awarded' && !value.packageSellInfo.sellPrice) {
        validations['packageSellInfo.sellPrice'] = 
        validations.sellPrice = this.getRequiredFieldValidationMessage('Sell Price');
      }
      if ((value.status === 'Awarded' || value.status === 'Pending Settle' || value.status === 'Settled (Sold)') && !value.packageSellInfo.originalSettledDate) {
        validations['packageSellInfo.originalSettledDate'] = 
        validations.originalSettledDate = this.getRequiredFieldValidationMessage('Target Settlement Date');
      }
      if ((value.status === 'Awarded' || value.status === 'Pending Settle' || value.status === 'Settled (Sold)') && !value.packageSellInfo.tradeDate) {
        validations['packageSellInfo.tradeDate'] = 
        validations.tradeDate = this.getRequiredFieldValidationMessage('Trade Date');
      }
      if ((value.status === 'Awarded' || value.status === 'Pending Settle' || value.status === 'Settled (Sold)') && !value.packageSellInfo.trader) {
        validations['packageSellInfo.trader'] = 
        validations.trader = this.getRequiredFieldValidationMessage('Trader');
      }
      if ((value.status === 'Settled (Sold)') && !value.packageSellInfo.offerDueDate){
        validations['packageSellInfo.offerDueDate'] = 
        validations.offerDueDate = this.getRequiredFieldValidationMessage('Cutoff Date');
      }
      if ((value.status === 'Settled (Sold)') && !value.packageSellInfo.settledDate) {
        validations['packageSellInfo.settledDate'] = 
        validations.settledDate = this.getRequiredFieldValidationMessage('Funding Settlement Date');
      }
    }

    return validations;
  }

  public Validate(value: ISellPackage): Promise<Validations<ISellPackage>> {
    //TODO: Implement async validation logic if needed
    throw new Error('Method not implemented.');
  }

  private getRequiredFieldValidationMessage(fullFieldName: string): string {
    return `${fullFieldName} is required.`;
  }

  private getEmptyFieldValidationMessage(fullFieldName: string): string {
    return `${fullFieldName} should be blank.`;
  }
}